import { cloneDeep, defaultsDeep } from 'lodash'

import { Supplier } from '../models/supplier.entity'

// Initial states

const SUPPLIER_INITIAL_STATE: Partial<Supplier> = {
  code: undefined,
  alias: undefined,
  businessName: undefined,
  address1: undefined,
  address2: undefined,
  city: undefined,
  province: undefined,
  postalCode: undefined,
  countryCode: undefined,
  fiscalCode: undefined,
  vat: undefined,
  phone: undefined,
  email: undefined,
  contactName: undefined,
  contactSurname: undefined,
}

// Init

export function initSupplier(supplier: Partial<Supplier> = {}): Supplier {
  return defaultsDeep(cloneDeep(supplier), SUPPLIER_INITIAL_STATE)
}
